import React from 'react';
import { useTranslation } from 'react-i18next';

type ToggleWithLabelProps = {
  checked: boolean;
  onChange: () => void;
};

export const ToggleWithLabel: React.FC<ToggleWithLabelProps> = ({ checked, onChange }) => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-2">
      {checked && (
        <span className="text-green-600 border border-green-500 px-2 py-1 text-xs rounded">
          {t('config.Active')}
        </span>
      )}
      <label className="inline-flex relative items-center cursor-pointer">
        <input
          type="checkbox"
          className="sr-only peer"
          checked={checked}
          onChange={onChange}
        />
        <div className="w-11 h-6 bg-gray-200 rounded-full peer peer-checked:bg-green-500 transition-all"></div>
        <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full shadow-md transform peer-checked:translate-x-full transition-all"></div>
      </label>
    </div>
  );
};